// Task-related types
import { SignificationConfig } from './signification.types';
import { PhotoConfig } from './photo.types';

export enum MediaType {
    Photo = 'photo',
    Video = 'video',
    Audio = 'audio',
    Text = 'text',
    Screen = 'screen',
    Signification = 'signification',
}

export type Recurrence = 'none' | 'daily' | 'weekly' | 'monthly';

export interface Task {
    id: string;
    projectId: string;
    organizationId?: string;
    mediaTypes: MediaType[];
    title: string;
    prompt: string;
    /** Researcher-recorded spoken prompt (voice-guided mode). Storage URL. */
    promptAudioUrl?: string;
    dueDate: string;
    timeEstimate: string;
    assignedParticipantIds?: string[];
    /** Saved with nobody assigned — held back from participants until someone
        is. Written explicitly on save rather than derived from an empty
        `assignedParticipantIds`, because tasks predating the assignment picker
        have no list and are legitimately visible to their whole project;
        inferring draft-ness would retroactively hide live studies. */
    isDraft?: boolean;
    recurrence?: Recurrence;
    status: 'active' | 'completed' | 'archived';
    customGroup?: string;
    createdAt?: string;
    screenTargetAppName?: string;
    screenDeepLinkUrl?: string;
    screenCaptureFaceCam?: boolean;
    isTemplate?: boolean;
    isUrgent?: boolean;
    createdBy?: string;
    /** Allow researcher to request a redo for this task (off by default) */
    allowRedo?: boolean;
    /** Max number of submission attempts when redo is enabled (includes original) */
    maxAttempts?: number;
    /** Allow participant to add supplementary data after submission (off by default) */
    allowAddendum?: boolean;
    /** Hours after original submission within which addendums are permitted */
    addendumWindowHours?: number;
    /** Signification Engine config — present when mediaTypes includes 'signification' */
    significationConfig?: SignificationConfig;
    /** Photo annotation config — present when photo task has annotations enabled */
    photoConfig?: PhotoConfig;
    /** Italic-accent word in the title — rendered in serif italic deep-coral
     *  under glass theme. Case-insensitive substring match. Researcher UI parked. */
    accentWord?: string;
}
